import type { GatsbyBrowser } from "gatsby";
import * as React from "react";

import Footer from "./src/components/Footer/footer";
import Header from "./src/components/Header/Header";
import CartState from "./src/context/cart/CartState";

import "./src/styles/global.css";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => {
  return (
    <CartState>
      <Header />

      <main className="md:space-y-32 space-y-16">{element}</main>
      <Footer />
    </CartState>
  );
};
